import { getSessionID, getXSRFToken } from 'workfront-cookie'

import { CONTENT_TYPE_FORM, CONTENT_TYPE_JSON } from './constants.js'
import { getAuthorizationHeader } from './configuration'

/**
 * @typedef {Object} WfTokenBasedAuthHeaders
 * @property {string} X-XSRF-TOKEN
 *
 * @typedef {Object} WfSessionBasedAuthHeaders
 * @property {string} sessionID
 *
 * @typedef {WfTokenBasedAuthHeaders & WfSessionBasedAuthHeaders} WfAuthHeaders
 */

/**
 * Returns a set of headers required for authentication
 * @returns {WfAuthHeaders}
 */
export function getAuthHeaders() {
  let headers = {}

  const token = getXSRFToken()
  const sessionID = getSessionID()
  const authorizationHeader = getAuthorizationHeader()

  if (token) {
    headers['X-XSRF-TOKEN'] = token
  } else if (sessionID) {
    headers.sessionID = sessionID
  }

  if (authorizationHeader) {
    headers.Authorization = authorizationHeader
  }

  return headers
}

export function getRedrockHeaders() {
  return {
    'X-Requested-With': 'XMLHttpRequest',
    ...getAuthHeaders(),
  }
}

export const FORM_CONTENT_TYPE_HEADER = {
  'Content-Type': CONTENT_TYPE_FORM,
}

export const JSON_CONTENT_TYPE_HEADER = {
  'Content-Type': CONTENT_TYPE_JSON,
}
